import { render, staticRenderFns } from "./TopUpDialog.vue?vue&type=template&id=463c7b9f&scoped=true"
import script from "./TopUpDialog.vue?vue&type=script&lang=js"
export * from "./TopUpDialog.vue?vue&type=script&lang=js"
import style0 from "./TopUpDialog.vue?vue&type=style&index=0&id=463c7b9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463c7b9f",
  null
  
)

export default component.exports